import { withNestedInfiniteDataList } from "../../../utils";
import { CustomModelAutomaticMutationSideEffectConfigs } from "../types";

export const CHAT_ROOMS_MUTATION_SIDE_EFFECT_CONFIGS: CustomModelAutomaticMutationSideEffectConfigs<"chat_rooms"> = {
  updateOne: (_, mutationResponse) => {
    const isInternal = mutationResponse?.type === "internal" || !mutationResponse?.enduserIds?.length;
    return {
      ...(isInternal
        ? {
            // Invalidate all load_team_chat queries until we have access to the current user ID in cache updates
            load_team_chat: {
              exact: false,
            },
          }
        : {}),
      _otherModels: {
        inbox_threads: {
          load_threads: {
            predicate: (query) =>
              query.state.data?.pages.some((page) =>
                page.threads.some((thread) => thread.type === "Chat" && thread.threadId === mutationResponse?.id)
              ) ?? false,
            request: { autobuild: true },
            exact: false,
            updater: (oldData) => {
              if (!mutationResponse) return oldData;
              return withNestedInfiniteDataList({
                infiniteData: oldData,
                listKey: "threads",
                operation: {
                  type: "upsert",
                  args: {
                    matchFn: (thread) => thread.type === "Chat" && thread.threadId === mutationResponse.id,
                    updater: (thread) => {
                      if (!thread) return undefined;
                      return {
                        ...thread,
                        ...(mutationResponse.assignedTo !== undefined
                          ? { assignedTo: mutationResponse.assignedTo }
                          : {}),
                        ...(mutationResponse.userIds !== undefined ? { userIds: mutationResponse.userIds } : {}),
                      };
                    },
                  },
                },
              });
            },
          },
        },
      },
    };
  },
  createOne: (_, mutationResponse) =>
    mutationResponse?.type === "internal" || !mutationResponse?.enduserIds?.length
      ? {
          // Invalidate all load_team_chat queries until we have access to the current user ID in cache updates
          load_team_chat: {
            exact: false,
          },
        }
      : {},
  deleteOne: (_, mutationResponse) =>
    mutationResponse
      ? {
          // Invalidate all load_team_chat queries until we have access to the current user ID in cache updates
          load_team_chat: {
            exact: false,
          },
        }
      : {},
  createSome: (_, mutationResponse) =>
    mutationResponse?.created.some((room) => room.type === "internal" || !room.enduserIds?.length)
      ? {
          // Invalidate all load_team_chat queries until we have access to the current user ID in cache updates
          load_team_chat: {
            exact: false,
          },
        }
      : {},
};
